import { useMemo, useState } from "react";

type DevBarAction = {
  text: string;
  onClick: () => void;
};

type UseLokaliseEditorOptions = {
  enabled: boolean;
  onEditorEnable?: () => void;
};

type UseLokaliseEditorResult = {
  editorEnabled: boolean;
  devBarActions: DevBarAction[];
};

/**
 * Hook for managing Lokalise in-context editor state and DevBar actions.
 *
 * @param options.enabled - Whether the Lokalise editor feature is available
 * @param options.onEditorEnable - Callback when the editor is enabled (e.g., to enable post processor)
 * @returns editorEnabled state and devBarActions for the DevBar component
 */
export function useLokaliseEditor({
  enabled,
  onEditorEnable,
}: UseLokaliseEditorOptions): UseLokaliseEditorResult {
  const [editorEnabled, setEditorEnabled] = useState(false);

  const devBarActions = useMemo(() => {
    const actions: DevBarAction[] = [];

    if (enabled && !editorEnabled) {
      actions.push({
        text: "lok",
        onClick: () => {
          setEditorEnabled(true);
          onEditorEnable?.();
        },
      });
    }

    if (editorEnabled) {
      actions.push({
        text: "lok-update",
        onClick: () =>
          document.dispatchEvent(new CustomEvent("lokalise-update-elements")),
      });
    }

    return actions;
  }, [enabled, editorEnabled, onEditorEnable]);

  return {
    editorEnabled,
    devBarActions,
  };
}
